export const Prices = [
  {
    _id: 0,
    name: "₹0 to 100",
    array: [0, 100],
  },
  {
    _id: 1,
    name: "₹100 to 300",
    array: [100, 300],
  },
  {
    _id: 2,
    name: "₹300 to 500",
    array: [300, 500],
  },
  {
    _id: 3,
    name: "₹500 to 1000",
    array: [500, 1000],
  },
  {
    _id: 4,
    name: "₹1000 to 5000",
    array: [1000, 5000],
  },
  {
    _id: 5,
    name: "₹5000 or more",
    array: [5000, 999999],
  },
];
